import React, {useMemo} from "react";
import {Hotspot} from "elements/hotspot";

export function HotspotRenderer(
  {
    isCreativeStudioPreviewMode,
    index,
    hotspot,
    isCardAndInVideoAndFinale,
    onHotspotClick,
    containerDimensions,
    isCardHotspot,
    useHotspotAnimation,
    isInVideoOverlay,
    isFinaleOverlay,
    isShowing,
    isStandaloneHotspots,
    isHotspotSelected,
    selectedHotspotSelector,
    hotspotPopperSelector,
    snappingHotspotSelector,
    shouldHide,
    
    showAttentionAnimation,
    animationIndex,
    onMouseOver,
    onMouseOut,
    resetKey,
    delayInitialAttentionAnimation,
    delayInitialAttentionAnimationForInVideo,
    onImageLoaded,
  }
) {

  const showing = useMemo(() => isShowing(hotspot), [hotspot, isShowing]);
  const isSelected = useMemo(() => isHotspotSelected ? isHotspotSelected(hotspot) : false, [hotspot, isHotspotSelected]);
  const hide = useMemo(() => shouldHide(hotspot, index), [hotspot, index, shouldHide]);

  if (hide) {
    return <React.Fragment key={index}/>
  }

  return <Hotspot
    hotspot={hotspot}
    onClick={onHotspotClick}
    index={index}
    containerDimensions={containerDimensions}
    showing={showing}
    isCardHotspot={isCardHotspot}
    useHotspotAnimation={useHotspotAnimation}
    isSelected={isSelected}
    selectedHotspotSelector={showing ? selectedHotspotSelector : null}
    hotspotPopperSelector={showing ? hotspotPopperSelector : null}
    snappingHotspotSelector={showing ? snappingHotspotSelector : null}
    isCreativeStudioPreviewMode={isCreativeStudioPreviewMode}

    showAttentionAnimation={showAttentionAnimation}
    animationIndex={animationIndex}
    onMouseOver={onMouseOver}
    onMouseOut={onMouseOut}
    resetKey={resetKey}
    delayInitialAttentionAnimation={delayInitialAttentionAnimation}
    delayInitialAttentionAnimationForInVideo={delayInitialAttentionAnimationForInVideo}
    onImageLoaded={onImageLoaded}
  />
}
